<template>
  <div
    class="workbench-container"
    :style="{
      backgroundImage: isLogin()
        ? ''
        : `url(https://image.zhihuishu.com/zhs_yufa_150820/b2cm/base1/202509/1429d0243d2b45ba9e1c596fc659bea9.png)`
    }"
  >
    <div
      class="top"
      :style="{
        backgroundImage: isLogin()
          ? 'url(https://image.zhihuishu.com/zhs_yufa_150820/b2cm/base1/202509/139284dffd584b79b4d8d30a0405f67a.png)'
          : '',
        height: !isLogin() ? '155px' : ''
      }"
    >
      <div class="title">
        <div class="left">
          <img v-if="!isLogin()" src="../../assets/images/guzhang.png" alt="" class="gu-icon" />
          <div style="display: flex; align-items: center">
            <span
              class="name"
              :style="{
                'max-width': !isLogin() ? '100%' : ''
              }"
            >
              {{
                isLogin()
                  ? `${userInfo && userInfo.realname}${
                      userRole > 1 ? userNameList[currentRole] : ''
                    }`
                  : '欢迎使用工作台'
              }}
            </span>
            <span v-if="isLogin()" class="hello">，您好</span>
            <img
              v-if="isLogin()"
              class="left-img"
              src="https://image.zhihuishu.com/zhs_yufa_150820/b2cm/base1/202509/e19b18fb2dd84c8f9ae46258ecf5fce6.png"
              alt=""
            />
            <img
              v-else
              class="left-img"
              src="https://image.zhihuishu.com/zhs_yufa_150820/b2cm/base1/202509/872362af67aa4643beb89165e53c0edd.png"
              alt=""
            />
          </div>
        </div>
        <div v-if="isLogin()" class="right">
          <span class="role">{{ userRoleList[currentRole] }}</span>
          <img
            v-if="userRole < 3 && userRole > 0"
            class="right-img"
            src="https://image.zhihuishu.com/zhs_yufa_150820/b2cm/base1/202509/12b2e166ead44a1a9abda2c80b1e760d.png"
            alt=""
            @click="toggleShowRole"
          />
        </div>
      </div>
      <a v-if="!isLogin()" :href="getLoginUrl()" referrerPolicy="no-referrer" class="btn login">
        去登录
        <el-icon><ArrowRightBold /></el-icon>
      </a>
      <div v-else class="btn" @click="handleOpenUrl(onlineUrl)">
        建课中心
        <el-icon><ArrowRightBold /></el-icon>
      </div>
    </div>
    <div v-if="isLogin()" class="operations">
      <template v-for="(item, index) in menuList" :key="index">
        <div class="item" @click="handleOpenUrl(item.jump_url)">
          <img class="item-img" :src="item.icon_url" />
          <span class="name">{{ item.app_name }}</span>
        </div>
      </template>
    </div>
    <!-- <div v-else class="empty">
      <img
        class="empty-img"
        src="https://image.zhihuishu.com/zhs_yufa_150820/b2cm/base1/202509/1256c97b9ed744a8bc071717f7f20bba.png"
        alt=""
      />
      <div>- 登录查看更多功能 -</div>
    </div> -->
  </div>
</template>

<script setup>
import { ref, onMounted, getCurrentInstance, watch } from 'vue'
import { getLoginUrl } from '@/plugins/utils'
import { ElMessage } from 'element-plus'
const props = defineProps({
  userRole: {
    type: Number,
    default: 0
  },
  userInfo: {
    type: Object,
    default: () => {}
  }
})
const menuList = ref([])
const onlineUrl = ref('')
const proxy = getCurrentInstance()
const currentRole = ref(3)
const userRoleList = ['未认证', '管理员', '老师', '学生']
const userNameList = ['', '管理员', '老师', '同学']
const roleList = ref([])

const toggleShowRole = () => {
  if (props.userRole == 0 || props.userRole == 3) {
    return
  }
  const index = roleList.value.findIndex(item => item.role === currentRole.value)
  if (index < roleList.value.length - 1) {
    currentRole.value = roleList.value[index + 1].role
  } else {
    currentRole.value = roleList.value[0].role
  }
  getOperationList(currentRole.value)
}

const isLogin = () => {
  return props.userInfo
}

const handleOpenUrl = url => {
  if (!url) return ElMessage.warning('暂无链接地址!')
  window.open(url)
}
const getOperationList = async role => {
  const params = {
    role_type: role
  }
  const data = await proxy.appContext.config.globalProperties.$http.getAppList(params)
  if (data && data.length > 0) {
    menuList.value = data.filter(item => item.app_name != 'zhs_dz_platform')
    const platform = data.find(item => item.app_name == 'zhs_dz_platform')
    if (platform) {
      onlineUrl.value = platform.jump_url
    }
  }
}

watch(
  () => props.userRole,
  val => {
    if (val) {
      currentRole.value = val
    }
    getOperationList(val)
    if (val === 1) {
      roleList.value = [
        { name: '管理员', role: 1 },
        { name: '教师', role: 2 },
        { name: '学生', role: 3 }
      ]
    } else if (val === 2) {
      roleList.value = [
        { name: '教师', role: 2 },
        { name: '学生', role: 3 }
      ]
    }
  },
  { immediate: true }
)

defineExpose({
  onlineUrl
})
</script>

<style lang="scss" scoped>
.workbench-container {
  width: 320px;
  height: 460px;
  background-color: #f7f8fa;
  border-radius: 16px;
  padding: 8px;
  background-size: contain;
  background-repeat: no-repeat;
  .top {
    height: 148px;
    border-radius: 12px;
    // background-image: url('https://image.zhihuishu.com/zhs_yufa_150820/b2cm/base1/202509/139284dffd584b79b4d8d30a0405f67a.png');
    background-size: cover;
    padding: 16px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    .title {
      display: flex;
      justify-content: space-between;
      .left {
        display: flex;
        flex-direction: column;
        width: 70%;
        .gu-icon {
          width: 24px;
          height: 26px;
          margin-bottom: 19px;
        }
        .name {
          max-width: 60%;
          font-family: PingFang SC Medium;
          font-weight: 500;
          font-size: 18px;
          line-height: 26px;
          letter-spacing: 0px;
          color: #1d2129;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          display: inline-block;
        }
        .hello {
          font-family: PingFang SC Medium;
          font-weight: 500;
          font-size: 18px;
          line-height: 26px;
          letter-spacing: 0px;
          color: #1d2129;
        }
        .left-img {
          width: 14px;
          height: 14px;
          margin-bottom: 12px;
          margin-left: 3px;
        }
      }
      .right {
        display: flex;
        align-items: center;
        .role {
          font-family: PingFang SC;
          font-weight: 400;
          font-size: 14px;
          line-height: 22px;
          letter-spacing: 0px;
          color: #1d2129;
        }
        .right-img {
          width: 20px;
          height: 20px;
          margin-left: 5px;
          cursor: pointer;
        }
      }
    }
    .btn {
      width: 106px;
      height: 38px;
      border-radius: 8px;
      background-color: var(--el-color-primary);
      font-family: PingFang SC;
      font-weight: 400;
      font-size: 14px;
      color: #ffffff;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      .el-icon {
        margin-top: 1px;
        margin-left: 5px;
      }
    }
  }
  .operations {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 30px 15px;
    margin-top: 40px;
    .item {
      display: flex;
      flex-direction: column;
      align-items: center;
      height: 100px;
      &:hover {
        .name {
          color: var(--el-color-primary);
        }
      }
      cursor: pointer;
      .item-img {
        width: 48px;
        height: 48px;
        border-radius: 8px;
      }
      .name {
        font-family: PingFang SC;
        font-weight: 400;
        font-size: 16px;
        color: #1d2129;
        padding-top: 15px;
      }
    }
  }
  .empty {
    display: flex;
    align-items: center;
    flex-direction: column;
    margin-top: calc(50% - 80px);
    .empty-img {
      width: 120px;
      height: 120px;
    }
    div {
      font-family: PingFang SC;
      font-weight: 400;
      font-size: 12px;
      color: #86909c;
    }
  }
  .login {
    width: 92px !important;
    height: 38px;
  }
}
</style>
